export default {
  rawColumns:[
  {
    dataIndex:'rawName',
    title:'原料名称',
    width: 120,
    ellipsis: true,
    // sorter: (a, b) => a.rawName.localeCompare(b.rawName,'zh'),
    // sortDirections: ['descend', 'ascend'],
    scopedSlots: {customRender: 'rawName'},
  },
  {
    dataIndex:'rawCode',
    title:'原料代码',
    ellipsis: true,
    // sorter: (a, b) => a.rawCode - b.rawCode,
    // sortDirections: ['descend', 'ascend'],
    // align:'center',
    width:100,
    scopedSlots: {customRender: 'rawName'},
  },
  {
    dataIndex:'price',
    title:'历史价格(元/吨)',
    ellipsis: true,
    // sorter: (a, b) => a.price - b.price,
    scopedSlots: {customRender: 'price'},
    // sortDirections: ['descend', 'ascend'],
    // align:'center',
    width:100
  },
  {
    dataIndex:'newestPrice',
    title:'最新价格(元/吨)',
    scopedSlots: {customRender: 'newestPrice'},
    ellipsis: true,
    width:100
    // sorter: (a, b) => a.newestPrice - b.newestPrice,
    // sortDirections: ['descend', 'ascend'],  
    // align:'center'
  },
  {
    dataIndex:'diffPrice',
    title:'差异(元/吨)',
    // sorter: (a, b) => a.diffPrice - b.diffPrice,
    scopedSlots: {customRender: 'diffPrice'},
    // sortDirections: ['descend', 'ascend'],
    // align:'center',
    width:100
  },
  {
    dataIndex:'percentage',
    title:'用量(%)',
    ellipsis: true,
    // sorter: (a, b) => a.percentage - b.percentage,
    // sortDirections: ['descend', 'ascend'],
    scopedSlots: {customRender: 'percentage'},
    // align:'center',
    width:100
  },
  {
    dataIndex:'uasge',
    title:'用量(批次量)',
    ellipsis: true,
    // sorter: (a, b) => a.uasge - b.uasge,
    scopedSlots: {customRender: 'uasge'},
    // sortDirections: ['descend', 'ascend'],
    // align:'center',
    width:100
  },{
    dataIndex:'minValue',
    title: '最小值',
    ellipsis: true,
    scopedSlots: {customRender: 'minValue'},
    width:100
  },
  {
    dataIndex:'maxValue',
    title: '最大值',
    ellipsis: true,
    scopedSlots: {customRender: 'maxValue'},
    width:100
  },
  {
    dataIndex:'minLimitValue',
    title: '极下限',
    ellipsis: true,
    scopedSlots: {customRender: 'minLimitValue'},
    width:100
  },
  {
    dataIndex:'maxLimitValue',
    title:'极上限',
    ellipsis: true,
    scopedSlots: {customRender: 'maxLimitValue'},
    width:100
  },
],
  nutColumns:[
  {
    dataIndex:'name',
    title:'指标名称',
    width:120,
    ellipsis: true,
  },
  // {
  //   dataIndex:'fullName',
  //   title:'指标全称',
  // },
  {
    dataIndex:'content',
    title:'数值',
    width:100,
    ellipsis: true,
    // sorter: (a, b) => a.content - b.content,
    // sortDirections: ['descend', 'ascend'],
    scopedSlots: {customRender: 'content'},
    // align:'center'
  },
  {
    dataIndex:'unit',
    title:'单位',
    width:100,
    ellipsis: true,
  },
  {
    dataIndex:'minValue',
    title: '最小值',
    ellipsis: true,
    scopedSlots: {customRender: 'minValue'},
    width:100
  },
  {
    dataIndex:'maxValue',
    title: '最大值',
    ellipsis: true,
    scopedSlots: {customRender: 'maxValue'},
    width:100
  },
  {
    dataIndex:'minLimitValue',
    title: '极下限',
    ellipsis: true,
    scopedSlots: {customRender: 'minLimitValue'},
    width:100
  },
  {
    dataIndex:'maxLimitValue',
    title:'极上限',
    ellipsis: true,
    scopedSlots: {customRender: 'maxLimitValue'},
    width:100
  },
]}